import { getCaptchaRequestConfig } from '../../../utils/get-captcha-request-config';
import { getGetGiftCardDetailsErrorV1 } from './errors/get-gift-card-details-error';
import { giftCardsApiRoutes as routes } from './routes';
export function getGiftCardsApiV1(httpClient) {
    return {
        getDetails: (giftCardCredentials, captchaResponse) => httpClient
            .post(routes.getDetails(), giftCardCredentials, getCaptchaRequestConfig(captchaResponse))
            .catch(async (e) => {
            throw await getGetGiftCardDetailsErrorV1(e);
        })
    };
}
//# sourceMappingURL=get-gift-cards-api.js.map